import * as v from "valibot";

export const quantitySchema = v.pipe(
  v.string(),
  v.regex(/^(\d+([.,]\d*)?|[.,]\d+)$/, "Invalid number"),
  v.transform((v) => Number(v.replace(",", ".")))
);
